import React from 'react';
import { Card, CardContent, CardMedia, Typography, Button, useTheme, useMediaQuery } from '@mui/material';
import { Link } from 'react-router-dom';

const InfoCard = ({ title, description, image, link, reverse }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // ✅ Check if small screen

  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: isMobile ? 'column' : reverse ? 'row-reverse' : 'row',
        borderRadius: 4,
        overflow: 'hidden',
        mb: 4,
        boxShadow: 3,
        width: '90%',
        maxWidth: '1100px',
        mx: 'auto',
        bgcolor: theme.palette.primary.main,
      }}
    >
      <CardMedia
        component="img"
        sx={{
          width: isMobile ? '100%' : '50%',
          height: isMobile ? 200 : 'auto',
          objectFit: 'cover',
        }}
        image={image}
        alt={title}
      />
      <CardContent
        sx={{
          width: isMobile ? '100%' : '60%',
          p: 3,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="h5"
          gutterBottom
          sx={{ color: theme.palette.background.default, fontWeight: 'bold' }}
        >
          {title}
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: theme.palette.background.default }}>
          {description}
        </Typography>
        <Button
          component={Link}
          to={link}
          variant="contained"
          sx={{
            alignSelf: 'flex-start',
            backgroundColor: theme.palette.background.default,
            color: theme.palette.primary.main,
            borderRadius: 2,
            textTransform: 'none',
            '&:hover': {
              backgroundColor: theme.palette.primary.dark,
              color: '#fff',
            },
          }}
        >
          Find Out More
        </Button>
      </CardContent>
    </Card>
  );
};

export default InfoCard;
